import { ArticleHeading2, ArticleHeading3, ArticleParagraph1, ArticleParagraph2, useDeviceType } from '@cian/ui-kit';
import React from 'react';
import { HowGetDeal } from 'shared/components/HowGetDeal';

export const HowGetDealContainer: React.FC = () => {
  const device = useDeviceType();

  const isPhone = device === 'phone';

  const ItemTitle = isPhone ? ArticleHeading3 : ArticleHeading2;

  const Description = isPhone ? ArticleParagraph2 : ArticleParagraph1;

  return <HowGetDeal device={device} ItemTitle={ItemTitle} Description={Description} />;
};
